module.exports = __webpack_public_path__ + "img/icon6.b109f176.png";